import React, { } from 'react'
import { useTranslation } from "react-i18next";
import styles from './EditDropDown.module.css'
import DropDownV2 from '../../UI/DropDownV2/DropDownV2';
import { Button } from 'react-bootstrap'


//props.management
//props.selectedDropDownItemObj
//props.dropDownLabel
//props.textLabel
//props.dropDownItems
//props.onSelectDropDownItem
//props.onDropDownNameChanged
//props.onDeleteDropDownItemClick
//props.onSaveDropDownItemClick
export default (props) => {
    const [t] = useTranslation('common')

    return (
        <div className={styles['selection-container']}>
            <div>
                <h2 className={styles.settingsTitle}>{props.management}</h2>
                <DropDownV2 nowSelected={props.selectedDropDownItemObj} onSelect={props.onSelectDropDownItem} label={props.dropDownLabel} defaultSelectedItemName={props.defaultSelectedItemName} items={props.dropDownItems} />

                <section className={styles.subSettingSection}>
                    <div className={styles.someSettingDiv}>
                        <span className={styles.specificSettingsText}>{props.textLabel}</span>
                        <input type='text' value={props.selectedDropDownItemObj?.key !== 'Create classification' ? t(props.selectedDropDownItemObj?.key) : ''} onChange={props.onDropDownNameChanged} className={styles.input} />
                    </div>
                    <div className={styles['dropdown--save-remove']}>
                        <Button className={styles.updateAutoMsgTimeClicked} variant='success' onClick={props.onSaveDropDownItemClick} >{t('save')}</Button>
                        {
                            props.selectedDropDownItemObj?.name !== 'Create classification' && props.selectedDropDownItemObj?._id && <Button className={styles.updateAutoMsgTimeClicked} variant='danger'
                                onClick={props.onDeleteDropDownItemClick}>{t('remove')}</Button>
                        }
                    </div>

                </section>
            </div>
            {props.children &&
                <div>
                    {props.children}
                </div>}
        </div>
    )
}